"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getByteLength = void 0;
/*
 * Browser compatible analog of node Buffer.byteLength
 * source: https://stackoverflow.com/questions/5515869/string-length-in-bytes-in-javascript
 */
function getByteLength(str) {
    var s = str.length;
    for (var i = str.length - 1; i >= 0; i--) {
        var code = str.charCodeAt(i);
        if (code > 0x7f && code <= 0x7ff)
            s++;
        else if (code > 0x7ff && code <= 0xffff)
            s += 2;
        if (code >= 0xDC00 && code <= 0xDFFF)
            i--;
    }
    return s;
}
exports.getByteLength = getByteLength;
//# sourceMappingURL=getByteLength.js.map